<script lang="ts" setup>
import type { Favorite } from '~~/server/api/insurance/assistance-services'

/* eslint-disable vue/no-v-html */
export interface PagesAssistenceServicesFavoriteProps {
    data: Favorite[]
}

const props = defineProps<PagesAssistenceServicesFavoriteProps>()
const { $t } = useNuxtApp()
const title = $t('Výber najobľúbenejších asistenčných služieb')
</script>

<template>
  <section
    id="asistencne-sluzby"
    class="scroll-margin-top-10"
  >
    <Tracker :data="{ position: title }">
      <BoxHeader
        :heading="title"
        heading-level="h2"
      />
      <div class="row justify-content-center">
        <div
          v-for="(favouriteService, fsIndex) in props.data"
          :key="`fs-${fsIndex}`"
          class="col-12 col-sm-6 col-lg-3"
        >
          <PagesAssistenceServicesFavoriteItem
            :service="favouriteService"
          />
        </div>
      </div>
    </Tracker>
  </section>
</template>
